import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {MarketingCampaignSearchModel} from "../marketing-campaign-search.model";
import {MarketingCampaignEntityModel} from "../marketing-campaign-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-marketing-campaign-search-page",
    templateUrl: "./marketing-campaign-search-page.component.html",
    providers: [provideSearchModel(MarketingCampaignSearchModel), provideEntityModel(MarketingCampaignEntityModel)]
})
export class MarketingCampaignSearchPageComponent extends AbstractSearchPage {
}
